const PAYMENT_ROUTES = [
  { screen: 'pagamento-sucesso', paths: ['/pagamento/sucesso', '/pagamento-sucesso'] },
  { screen: 'pagamento-falha', paths: ['/pagamento/falha', '/pagamento-falha'] },
  { screen: 'pagamento-pendente', paths: ['/pagamento/pendente', '/pagamento-pendente'] },
];

function normalizePath(value = '') {
  const path = value.trim().toLowerCase().replace(/\/+$/, '');
  return path || '/';
}

export function parsePaymentReturn(locationLike = window.location) {
  const hashValue = (locationLike.hash || '').replace(/^#/, '');
  const [hashPath = '', hashQuery = ''] = hashValue.split('?');
  const candidates = [normalizePath(locationLike.pathname), normalizePath(hashPath)];
  const matchedRoute = PAYMENT_ROUTES.find(route => route.paths.some(path => candidates.includes(path)));

  const params = new URLSearchParams(locationLike.search || '');
  const hashParams = new URLSearchParams(hashQuery);
  hashParams.forEach((value, key) => {
    if (!params.has(key)) params.set(key, value);
  });

  return {
    screen: matchedRoute?.screen || null,
    paymentId: params.get('payment_id') || params.get('collection_id'),
    subscriptionId: params.get('preapproval_id') || params.get('subscription_id'),
    status: params.get('status') || params.get('collection_status'),
    externalReference: params.get('external_reference'),
    merchantOrderId: params.get('merchant_order_id'),
  };
}